module.exports = __webpack_public_path__ + "img/product_2.fc5b852.webp";